export default {
  "test": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["testdzedzdee"])},
  "homepage": {
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["about"])},
    "portfolio": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["portfolio"])},
    "contact": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["contact"])}
  }
}